import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useEffect, useRef, useState } from 'react';
/**
 *
 * @param fn - Fetch function
 * @param conditionFn - The condition for the polling to finish
 * @param timeoutMs - Timeout duration in ms
 * @param maxDurationMs - [Optional] Max polling duration unless the condition is met
 * @returns
 */

export var useAsyncPolling = function useAsyncPolling(fn, conditionFn, timeoutMs, maxDurationMs) {
  var tick = useRef(0);
  var timeout = useRef();

  var _useState = useState(false),
      isPolling = _useState[0],
      setIsPolling = _useState[1];

  var _useState2 = useState(false),
      pollingFinished = _useState2[0],
      setPollingFinished = _useState2[1];

  var clear = useCallback(function () {
    clearTimeout(timeout.current);
    setIsPolling(false);
    tick.current = 0;
  }, []);
  var poll = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var res, hasReachedMaxDuration;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fn();

          case 2:
            res = _context.sent;
            hasReachedMaxDuration = !maxDurationMs ? false : maxDurationMs <= timeoutMs * tick.current;

            if (conditionFn(res) || hasReachedMaxDuration) {
              setPollingFinished(true);
              clear();
            } else {
              clearTimeout(timeout.current);
              timeout.current = setTimeout(function () {
                tick.current += 1;
                poll();
              }, timeoutMs);
            }

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), [timeoutMs, maxDurationMs, fn, conditionFn, clear]);
  var start = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!isPolling) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt("return");

          case 2:
            setIsPolling(true);
            setPollingFinished(false);
            poll();

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [isPolling, poll]);
  useEffect(function () {
    return function () {
      return clear();
    };
  }, [clear]);
  return {
    pollingFinished: pollingFinished,
    isPolling: isPolling,
    tick: tick,
    start: start,
    clear: clear
  };
};